
import { notification } from 'antd';

const MoreAction = ({ onClose, sponsor_Link }) => {

  const handleMenuClick = async (menu) => {
    switch (menu) {
      case 'sponsor_Link':
        navigator.clipboard.writeText(sponsor_Link)
        notification.open({
          message: 'Copied!',
          placement: 'bottomRight',
          duration: 1,
          style: { width: 200 }
        });
        onClose()
        break
      default:
        break
    }
  }

  return (
    <div className="component-parent">
      {/* <div className="component-775">
        <div className="arrow-outward-fill0-wght400-gr-parent">
          <img
            className="arrow-outward-fill0-wght400-gr-icon"
            alt=""
            src={require("../../assets/images/arrow_outward.svg").default}
          />
          <div className="view-application">View Application</div>
        </div>
      </div>
      <div className="component-776">
        <div className="shuffle-fill0-wght400-grad0-op-parent">
          <img
            className="arrow-outward-fill0-wght400-gr-icon"
            alt=""
            src={require("../../assets/images/shuffle.svg").default}
          />
          <div className="view-application">Reassign Membership</div>
        </div>
      </div> */}
      <div className="component-777" onClick={() => handleMenuClick('sponsor_Link')}>
        <div className="shuffle-fill0-wght400-grad0-op-parent">
          <div className="vector-wrapper3">
            <img className="vector-icon9" alt=""
              src={require("../../assets/images/copy.svg").default}
            />
          </div>
          <div className="view-application">Copy Sponsorship Link</div>
        </div>
      </div>
      {/* <div className="component-778">
        <div className="close-fill0-wght400-grad0-opsz-parent">
          <img
            className="arrow-outward-fill0-wght400-gr-icon"
            alt=""
            src={require("../../assets/images/close.svg").default}
          />
          <div className="view-application">Remove from group</div>
        </div>
      </div> */}
    </div>
  );
};

export default MoreAction;
